import { NgFor } from "@angular/common";
import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
} from "@angular/core";
import { GemSkeletonComponent } from "./gem-skeleton.component";

@Component({
  selector: "gem-skeleton-table",
  styleUrls: ["gem-skeleton-table.component.scss"],
  template: `
    <div class="skeleton-row" *ngFor="let r of rowIndexes">
      <div class="cell" *ngFor="let c of columnIndexes">
        <gem-skeleton height="1.25rem"></gem-skeleton>
      </div>
    </div>
  `,
  host: {
    role: "status",
    "aria-busy": "true",
    "[class.aligned]": "!!template",
    "[style.--gem-skeleton-columns]": "columns",
    "[style.--gem-skeleton-template]": "template",
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [NgFor, GemSkeletonComponent],
})
export class GemSkeletonTableComponent implements AfterViewInit {
  rowIndexes: number[] = [];
  columnIndexes: number[] = [];
  template: string | null = null;

  /** Table (or a wrapper around it) whose `th` cells the skeleton columns line up with. */
  @Input() alignTo?: HTMLElement;

  @Input() set rows(rows: number) {
    this.rowIndexes = Array.from({ length: rows }, (_, i) => i);
  }
  @Input() set columns(columns: number) {
    this._columns = columns;
    this.columnIndexes = Array.from({ length: columns }, (_, i) => i);
  }
  get columns(): number {
    return this._columns;
  }
  private _columns = 5;

  constructor(private cdr: ChangeDetectorRef) {
    this.rows = 8;
    this.columns = 5;
  }

  ngAfterViewInit(): void {
    // The header is rendered by then; fall back to equal columns if it is hidden (e.g. handset).
    const widths = Array.from(this.alignTo?.querySelectorAll("th") ?? []).map(
      (th) => th.getBoundingClientRect().width,
    );
    if (widths.length > 0 && widths.every((width) => width > 0)) {
      this.columns = widths.length;
      this.template = widths.map((width) => `${width}px`).join(" ");
      this.cdr.markForCheck();
    }
  }
}
